const activeColor = "POPGREYMID";
const openColor = "POPORANGE";

export default {
  id: "participate-engagements",
  type: "symbol",
  source: "engagements",
  layout: {
    "icon-allow-overlap": true,
    "icon-image": [
      "match",
      ["get", "Status"],
      ["Active"],
      [
        "match",
        ["get", "Category"],
        ["Major Projects"],
        `MajorProjects_${activeColor}`,
        ["Health and Wellbeing"],
        `Wellbeing_${activeColor}`,
        ["Community"],
        `Community_${activeColor}`,
        ["Technology"],
        `Wifi_${activeColor}`,
        ["Transport and Movement"],
        `TransportMovement_${activeColor}`,
        ["Parks and Recreation"],
        `ParksRecreation_${activeColor}`,
        ["Arts and Culture"],
        `ArtsCulture_${activeColor}`,
        ["Planning, Design and Renewal"],
        `PlanningDesign_${activeColor}`,
        ["Environment"],
        `Environment_${activeColor}`,
        ""
      ],
      ["Open"],
      [
        "match",
        ["get", "Category"],
        ["Major Projects"],
        `MajorProjects_${openColor}`,
        ["Health and Wellbeing"],
        `Wellbeing_${openColor}`,
        ["Community"],
        `Community_${openColor}`,
        ["Technology"],
        `Wifi_${openColor}`,
        ["Transport and Movement"],
        `TransportMovement_${openColor}`,
        ["Parks and Recreation"],
        `ParksRecreation_${openColor}`,
        ["Arts and Culture"],
        `ArtsCulture_${openColor}`,
        ["Planning, Design and Renewal"],
        `PlanningDesign_${openColor}`,
        ["Environment"],
        `Environment_${openColor}`,
        ""
      ],
      ""
    ]
  }
};
